import { render, staticRenderFns } from "./bucketInfo.vue?vue&type=template&id=bd01a740"
import script from "./bucketInfo.vue?vue&type=script&lang=js"
export * from "./bucketInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports